import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Link } from 'react-router-dom';
import * as actionCreator from '../actions/logBookActions';
import { withFirebaseAuth } from '../auth/withFirebaseAuth';
import * as moment from 'moment';  //Format date
import './css/LogBookAircraft.css';
import { Log } from "../class/Log";
import LogBookPopup from "./popup/LogBookPopup";
import MyPopover from "./element/MyPopover";
import ConfirmPopup from './popup/ConfirmPopup';
import { LookupItem } from './../class/LookupItem';
import { FlyTime } from '../class/flyTime';
import Select from 'react-select';


const yearList: LookupItem[] = [];
const currentYear = new Date().getFullYear();
for (let i = currentYear; i > currentYear - 10; i--) {
    let item = { label: (i).toString(), value: i }
    yearList.push(item);
}

interface Props {
    navigation: any;

    logBookList: Array<Log>;
    flyTime: FlyTime;
    pilotLicence: any;
    isLogSaved: boolean;
    isLogDeleted: boolean;
    firebaseAuth: any;
    getLogBookList(token: any, year: number): void;
    getTotalFlyTime(token: any): void;
    getPilotLicence(token: any): void;
    savePilotLicence(token: any, licence: any): void;
    deleteLog(token: any, logId: any): void;
}

interface State {
    selectedLog: Log,
    showPopupLog: boolean,
    token: any;
    popupTitle: string,
    isLogSaved: boolean,
    showConfirmPopup: boolean,
    selectedYear: any,
    editingLicence: boolean,
    licenceDraft: any,
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        logBookList: state.logBookList,
        flyTime: state.flyTime,
        pilotLicence: state.pilotLicence,
        isLogSaved: state.isLogSaved,
        isLogDeleted: state.isLogDeleted,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        getLogBookList: (token: any, year: number) => dispatch<any>(actionCreator.getLogList(token, year)),
        deleteLog: (token: any, logId: any) => dispatch<any>(actionCreator.deleteLog(token, logId)),
        getTotalFlyTime: (token: any) => dispatch<any>(actionCreator.getTotalFlyTime(token)),
        getPilotLicence: (token: any) => dispatch<any>(actionCreator.getPilotLicence(token)),
        savePilotLicence: (token: any, licence: any) => dispatch<any>(actionCreator.savePilotLicence(token, licence)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFirebaseAuth(class LogBookAircraft extends React.Component<Props, State>{
    static displayName = LogBookAircraft.name;
    
    constructor(props: any) {
        super(props);

        this.state = {
            token: null,
            popupTitle: "",
            selectedLog: {},
            showPopupLog: false,
            isLogSaved: false,
            showConfirmPopup: false,
            selectedYear: { label: new Date().getFullYear().toString(), value: new Date().getFullYear() },
            editingLicence: false,
            licenceDraft: {},
        };
    };

    async componentDidMount() {
        try {
            const token = await this.props.firebaseAuth.getAccessToken();
            if (token) {
                this.props.getLogBookList(token, this.state.selectedYear.value);
                this.props.getTotalFlyTime(token);
                this.props.getPilotLicence(token);
                this.setState({
                    token: token
                })
            }
        } catch (err) {
            // handle error as needed
        }
    }

    handleAddLog = (log: any) => {
        this.setState({
            popupTitle: "New Log",
            selectedLog: {},
            showPopupLog: true
        });
    }

    handleEditLog = (log: any) => {
        this.setState({
            popupTitle: "Edit Log",
            selectedLog: log,
            showPopupLog: true
        });
    }

    handleDeleteLog = (log: any) => {
        this.setState({
            selectedLog: log,
            showConfirmPopup: true
        });
    }

    handleConfirmDelete = (confirmDelete: boolean) => {
        if (confirmDelete) {
            this.setState({ showConfirmPopup: false });
            this.props.deleteLog(this.state.token, this.state.selectedLog.logBookId);
        }
        else {
            this.setState({
                showConfirmPopup: false,
            });
        }
    }

    handleCloseLogPopup = () => {
        this.setState({
            showPopupLog: false,
        });
    }

    handleChangeYear = (year: any) => {
        this.setState({
            selectedYear: year,
        })
        this.props.getLogBookList(this.state.token, year.value);
    }

    handleEditLicence = () => {
        this.setState({
            editingLicence: true,
            licenceDraft: {
                sepExpiry: this.props.pilotLicence?.sepExpiry ? moment.parseZone(this.props.pilotLicence.sepExpiry).format('YYYY-MM-DD') : '',
                irExpiry: this.props.pilotLicence?.irExpiry ? moment.parseZone(this.props.pilotLicence.irExpiry).format('YYYY-MM-DD') : '',
                medicalExpiry: this.props.pilotLicence?.medicalExpiry ? moment.parseZone(this.props.pilotLicence.medicalExpiry).format('YYYY-MM-DD') : '',
            }
        });
    }

    handleLicenceDraftChange = (e: any) => {
        this.setState({ licenceDraft: { ...this.state.licenceDraft, [e.target.id]: e.target.value } });
    }

    handleSaveLicence = () => {
        this.props.savePilotLicence(this.state.token, {
            SepExpiry: this.state.licenceDraft.sepExpiry || null,
            IrExpiry: this.state.licenceDraft.irExpiry || null,
            MedicalExpiry: this.state.licenceDraft.medicalExpiry || null,
        });
        this.setState({ editingLicence: false });
    }

    //navigate = useNavigate();
    navigateAdminPage = () => {
        // navigation('/home');
    };

    render() {
        const { navigation } = this.props;

        if (!this.props.firebaseAuth?.isAuthenticated) return <div>Loading...</div>;

        const expiryStatus = (dateStr: string | null | undefined): 'ok' | 'warn' | 'danger' | 'none' => {
            if (!dateStr) return 'none';
            const days = Math.floor((new Date(dateStr).getTime() - Date.now()) / 86400000);
            if (days < 0) return 'danger';
            if (days <= 30) return 'danger';
            if (days <= 90) return 'warn';
            return 'ok';
        };

        const statusColor = { ok: '#28a745', warn: '#fd7e14', danger: '#dc3545', none: '#6c757d' };
        const statusIcon  = { ok: 'fa-check-circle', warn: 'fa-exclamation-circle', danger: 'fa-times-circle', none: 'fa-question-circle' };

        const licence = this.props.pilotLicence;
        const sepStatus     = expiryStatus(licence?.sepExpiry);
        const irStatus      = expiryStatus(licence?.irExpiry);
        const medStatus     = expiryStatus(licence?.medicalExpiry);

        const fmtDate = (d: string | null | undefined) =>
            d ? moment.parseZone(d).format('DD/MM/YYYY') : '—';

        let flightTime = 0;
        let soloTime = 0;
        let landing = 0;
        let totalFlightTime = 0;
        let totalSoloTime = 0;
        let totalLanding = 0;

        this.props.logBookList.forEach(item => {
            landing = landing + (item.logBookLanding !== undefined ? item.logBookLanding : 0);
            flightTime = flightTime + (item.logBookTotalFlightTime !== undefined ? item.logBookTotalFlightTime : 0);

            if (!item.logBookDual) {
                soloTime = soloTime + (item.logBookTotalFlightTime !== undefined ? item.logBookTotalFlightTime : 0)
            }
        })
        soloTime = Math.round(soloTime * 100) / 100;
        flightTime = Math.round(flightTime * 100) / 100;

        let displayList = this.props.logBookList.map((item, index) => (
            <tr key={index} className="table-row">
                <td className="date-cell">
                    <span className="date-text">
                        {moment.parseZone(item.logBookDate).format('DD/MM/YYYY')}
                    </span>
                </td>
                <td className="d-none d-lg-table-cell">
                    {item.userAircraft?.aircraftModel?.aircraftModelName || ""}
                </td>
                <td className="registration-cell">
                    <span className="badge bg-light text-dark">
                        {item.userAircraft?.aircraftRegistration || ""}
                    </span>
                </td>
                <td className="airport-cell">
                    <span className="airport-code">
                        {item.airportDeparture?.airportCode || ""}
                    </span>
                </td>
                <td className="d-none d-lg-table-cell time-cell">
                    {item.logBookDepartureTime}
                </td>
                <td className="airport-cell">
                    <span className="airport-code">
                        {item.airportArrival?.airportCode || ""}
                    </span>
                </td>
                <td className="d-none d-lg-table-cell time-cell">
                    {item.logBookArrivalTime}
                </td>
                <td className="flight-time-cell">
                    <strong>
                        {item.logBookTotalFlightTime ? Math.round(item.logBookTotalFlightTime * 100) / 100 : ""}
                    </strong>
                </td>
                <td className="d-none d-lg-table-cell text-center checkmarks-cell">
                    <div className="checkmarks-container">
                        {item.logBookIFR === true && (
                            <span className="check-badge ifr" title="IFR">I</span>
                        )}
                        {item.logBookNight === true && (
                            <span className="check-badge night" title="Night">N</span>
                        )}
                        {item.logBookPIC === true && (
                            <span className="check-badge pic" title="PIC">P</span>
                        )}
                        {item.logBookCoPilot === true && (
                            <span className="check-badge copilot" title="Co-Pilot">C</span>
                        )}
                        {item.logBookDual === true && (
                            <span className="check-badge dual" title="Dual">D</span>
                        )}
                    </div>
                </td>
                <td className="landing-cell">
                    {item.logBookLanding}
                </td>
                <td className="actions-cell">
                    <div className="d-flex align-items-center gap-2">
                        {item.logBookDescription !== undefined && (
                            <MyPopover content={item.logBookDescription} />
                        )}
                        <div className="btn-group btn-group-sm" role="group">
                            <button 
                                className="btn btn-outline-primary"
                                onClick={() => this.handleEditLog(item)}
                                title="Edit log"
                            >
                                <i className="fas fa-edit"></i>
                            </button>
                            <button 
                                className="btn btn-outline-danger"
                                onClick={() => this.handleDeleteLog(item)}
                                title="Delete log"
                            >
                                <i className="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        ));

        return (
            <div className="logbook-container">
                <div className="logbook-header">
                    <div className="notifications">
                        {this.props.isLogSaved && (
                            <div className="alert alert-success" role="alert">
                                <i className="fas fa-check-circle me-2"></i>
                                New log added!
                            </div>
                        )}
                        {this.props.isLogDeleted && (
                            <div className="alert alert-success" role="alert">
                                <i className="fas fa-check-circle me-2"></i>
                                Deleted!
                            </div>
                        )}
                    </div>

                    <div className="flight-stats">
                        <div className="stats-card">
                            <div className="stat-item">
                                <span className="stat-label">Flight Time</span>
                                <span className="stat-value">
                                    {flightTime} / <span className="total-value">{this.props.flyTime.totalFlyTime}</span>
                                </span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-label">Solo</span>
                                <span className="stat-value">
                                    {soloTime} / <span className="total-value">{this.props.flyTime.totalSolo}</span>
                                </span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-label">Landing</span>
                                <span className="stat-value">
                                    {landing} / <span className="total-value">{this.props.flyTime.totalLanding}</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flight-stats">
                        <div className="stats-card">
                            <div className="stats-card-header">
                                <span style={{ fontSize: '0.8rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Licences</span>
                                {!this.state.editingLicence && (
                                    <button className="btn btn-sm btn-link p-0 ms-2" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem' }} onClick={this.handleEditLicence}>
                                        <i className="fas fa-edit"></i>
                                    </button>
                                )}
                            </div>
                            {!this.state.editingLicence ? (
                                <>
                                    {[
                                        { label: 'SEP', status: sepStatus, date: fmtDate(licence?.sepExpiry) },
                                        { label: 'IR',  status: irStatus,  date: fmtDate(licence?.irExpiry) },
                                        { label: 'Medical', status: medStatus, date: fmtDate(licence?.medicalExpiry) },
                                    ].map(({ label, status, date }) => (
                                        <div className="stat-item" key={label}>
                                            <span className="stat-label">
                                                <i className={`fas ${statusIcon[status]} me-1`} style={{ color: statusColor[status] }}></i>
                                                {label}
                                            </span>
                                            <span className="stat-value" style={{ color: statusColor[status] }}>{date}</span>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    {[
                                        { label: 'SEP', id: 'sepExpiry' },
                                        { label: 'IR',  id: 'irExpiry' },
                                        { label: 'Medical', id: 'medicalExpiry' },
                                    ].map(({ label, id }) => (
                                        <div className="stat-item" key={id} style={{ gap: '0.5rem' }}>
                                            <span className="stat-label" style={{ minWidth: '60px' }}>{label}</span>
                                            <input
                                                id={id}
                                                type="date"
                                                value={this.state.licenceDraft[id] || ''}
                                                onChange={this.handleLicenceDraftChange}
                                                style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '4px', color: 'white', fontSize: '0.8rem', padding: '2px 6px', width: '130px' }}
                                            />
                                        </div>
                                    ))}
                                    <div className="stat-item" style={{ justifyContent: 'flex-end', gap: '0.5rem', marginTop: '0.25rem' }}>
                                        <button className="btn btn-sm btn-light" style={{ fontSize: '0.75rem', padding: '2px 10px' }} onClick={this.handleSaveLicence}>
                                            <i className="fas fa-save me-1"></i>Save
                                        </button>
                                        <button className="btn btn-sm btn-outline-light" style={{ fontSize: '0.75rem', padding: '2px 10px' }} onClick={() => this.setState({ editingLicence: false })}>
                                            Cancel
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="logbook-content">
                    <div className="card shadow-sm">
                        <div className="card-header">
                            <div className="header-content">
                                <h5 className="card-title mb-0">
                                    <i className="fas fa-plane me-2"></i>
                                    My Flight Logs
                                </h5>
                                <div className="header-controls">
                                    <div className="year-selector">
                                        <Select
                                            id="logBookAircraftModel"
                                            onChange={this.handleChangeYear}
                                            options={yearList}
                                            value={this.state.selectedYear}
                                            className="year-select"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    padding: '0px',
                                                    minHeight: '32px',
                                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                                    borderRadius: '6px',
                                                    fontSize: '13px',
                                                    boxShadow: 'none',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        borderColor: 'rgba(255, 255, 255, 0.5)'
                                                    }
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999
                                                }),
                                                menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: '#495057',
                                                    backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#e9ecef' : 'white',
                                                    cursor: 'pointer'
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: 'white'
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    color: 'white',
                                                    cursor: 'pointer'
                                                }),
                                                indicatorSeparator: () => ({
                                                    display: 'none'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className="action-buttons-header">
                                        <button
                                            onClick={this.handleAddLog}
                                            className="btn btn-sm btn-light"
                                            title="Add new log"
                                        >
                                            <i className="fas fa-plus me-1"></i>
                                            Add Log
                                        </button>
                                        <button
                                            onClick={this.handleAddLog}
                                            className="btn btn-sm btn-outline-light"
                                            title="Export to Excel"
                                        >
                                            <i className="fas fa-file-excel me-1"></i>
                                            Export
                                        </button>
                                        <Link
                                            to="/LogBookAdmin"
                                            className="btn btn-sm btn-outline-light"
                                            title="Admin settings"
                                        >
                                            <i className="fas fa-cog me-1"></i>
                                            Admin
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col">Date</th>
                                            <th scope="col" className="d-none d-lg-table-cell">Model</th>
                                            <th scope="col">Reg.</th>
                                            <th scope="col">Dept.</th>
                                            <th scope="col" className="d-none d-lg-table-cell">Time</th>
                                            <th scope="col">Arri.</th>
                                            <th scope="col" className="d-none d-lg-table-cell">Time</th>
                                            <th scope="col">Total</th>
                                            <th scope="col" className="d-none d-lg-table-cell">Conditions</th>
                                            <th scope="col">Land.</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayList}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <LogBookPopup show={this.state.showPopupLog} popupTitle={this.state.popupTitle} log={this.state.selectedLog} hide={this.handleCloseLogPopup} token={this.state.token} />
                <ConfirmPopup show={this.state.showConfirmPopup} hide={this.handleConfirmDelete} title="Delete Log" content="Do you really want to delete this log from your logbook ?" />
            </div>)
    }
}))
